import { w as withConfigTransport } from "../../../services/config-transport/withConfigTransport-31ef3979.mjs";
import { _ as _VaFileUploadSingleItem } from "./VaFileUploadSingleItem-b556fafa.mjs";
const VaFileUploadSingleItem = withConfigTransport(_VaFileUploadSingleItem);
export {
  VaFileUploadSingleItem as V
};
//# sourceMappingURL=index-19908b4a.mjs.map
